import { AiComponentCompileError } from '@Pages/pageRuntime/compiler/AiComponentCompileError';
import { componentSourcePath } from '@Pages/pageRuntime/designMode/sourceMetadata';
import React, { createContext, useContext } from 'react';

export type SharedComponentImplementations = Record<string, React.ComponentType | Error>;

export const SharedComponentImplementationsContext = createContext<SharedComponentImplementations>(
  {}
);

const forwardingSharedComponents = new Map<string, React.ComponentType>();

function createForwardingSharedComponent(name: string): React.ComponentType {
  return function ForwardingSharedComponent(props) {
    'use memo';

    const implementations = useContext(SharedComponentImplementationsContext);
    const Component = implementations[name];

    if (!Component) {
      throw new AiComponentCompileError(
        `Sdk.Custom.${name} is referenced by this page but no published shared component has that exact name.`,
        { sourcePath: componentSourcePath(name) }
      );
    }

    if (Component instanceof Error) {
      throw Component;
    }

    return React.createElement(Component, props);
  };
}

export function forwardingSharedComponent(name: string): React.ComponentType {
  const existing = forwardingSharedComponents.get(name);

  if (existing) {
    return existing;
  }

  const component = createForwardingSharedComponent(name);
  forwardingSharedComponents.set(name, component);

  return component;
}
